function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.294.6L1.535 5.326a1.99 1.99 0 000 2.829l3.31 3.288c.786.78 2.06.78 2.847 0l4.69-4.658c.373-.372.585-.875.589-1.4l.024-3.372A2.007 2.007 0 0010.974 0L7.71.014a2.02 2.02 0 00-1.416.585zm4.058 3.058a.774.774 0 01-1.089 0 .761.761 0 010-1.082.774.774 0 011.09 0c.3.3.3.784 0 1.082zM.997 8.75a2 2 0 00.46 2.115l1.964 1.964a4 4 0 005.657 0l3.482-3.482a1.5 1.5 0 00.44-1.06v-.78L9.078 11.43c-.068.069-.139.135-.211.197l-.496.496a3 3 0 01-4.243 0l-.498-.499a4.08 4.08 0 01-.208-.194L1.457 9.465a1.993 1.993 0 01-.46-.715z",
  fill: "#8F90A6"
});

function SvgTagsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTagsIcon;